const config = require('../fundraiser-config');

const DonateNow = () => {
    return (
        <a className="bg-green-700 text-white font-bold text-base text-center no-underline w-4/5 sm:w-1/3 pt-3 pb-3 rounded-md" href={config.urls.donate}>Donate Now</a>
    )
};

export default DonateNow;